module.exports = __webpack_public_path__ + "img/why3.e319ccf4.png";